module.exports = __webpack_public_path__ + "img/img01.f9e1c89d.png";